/**
 * Объект целей для записи на прием
 * @typedef {object} AppointmentYandexGoals
 *
 * @property {string} timerRedirectToMedtochka - Редирект на Медточку по таймеру
 * @property {string} clickRedirectToMedtochka - Редирект на Медточку по клику на кнопку "Детали записи"
 * @property {string} clickServiceListSlotDirect - Редирект на страницу ПЗ по клику на слот(список LPU на диагностике)
 * @property {string} servicesSynonymModalOpen - Открытие модалки с синонимами после клика на селект
 * @property {string} servicesSynonymModalOpenError - Открытие диалогового окна с ошибкой после неудачной загрузки синонимов в модалку
 * @property {string} servicesSynonymSelected - Клик на синоним в модалке
 *
 * @property {string} clickConfirmPhone - Подтверждение номера. Нажать активную кнопку Подтвердить номер
 * @property {string} phoneConfirmed - Подтверждение номера. Номер успешно подтвержден
 * @property {string} openFormDirect - ПЗ. Переход в форму прямой записи
 * @property {string} clickAppointmentDirect - ПЗ. Нажать активную кнопку Записаться
 * @property {string} successDirect - ПЗ. Успешная прямая запись (в том числе при выборе Обычная запись в клубной форме)
 * @property {string} showCodeInput - Появился инпут ввода кода для подтверждения телефона
 * @property {string} confirmedByCall - Успешное подтверждение номера телефона через звонок
 * @property {string} confirmedBySms - Успешное подтверждение номера телефона через СМС
 *
 * @property {string} serviceOpenFormDirect - Форма записи. ПЗ. Переход в форму прямой записи (услуги)
 * @property {string} serviceClickAppointmentDirect - Форма записи. ПЗ. Нажать активную кнопку Записаться (услуги)
 * @property {string} serviceOpenFormWithDoctor - ПЗ. Услуги. Открылась форма с врачом
 * @property {string} serviceOpenFormWithEquipment - ПЗ. Услуги. Открылась форма с оборудованием
 * @property {string} serviceOpenDoctorList - ПЗ. Услуги. Открыто окно выбора врача
 * @property {string} serviceSelectedDoctorKnown - ПЗ. Услуги. Выбрали нового врача (известный)
 * @property {string} serviceSelectedDoctorUnknown - ПЗ. Услуги. Выбрали нового врача (неизвестный)
 * @property {string} serviceOpenEquipmentList - ПЗ. Услуги. Выбрали новое оборудование (неизвестное)
 * @property {string} serviceSelectedEquipmentKnown - ПЗ. Услуги. Выбрали новое оборудование (известное)
 * @property {string} serviceSelectedEquipmentUnknown - ПЗ. Услуги. Открыто окно выбора оборудования
 *
 * @property {string} serviceOpenModalPreliminaryConsultation - ОЗ. Операции. Открылась модалка о необходимости первичной консультации
 * @property {string} serviceClickConfirmPreliminaryConsultation - ОЗ. Операции. Пользователь на модалке кликнул Записаться к врачу
 * @property {string} serviceClickDeclinePreliminaryConsultation - ОЗ. Операции. Пользователь на модалке кликнул Отменить
 * @property {string} serviceFirstSelectedDoctorConsultation - ОЗ. Операции. Выбрали первичную консультацию (при обновлении врача)
 * @property {string} serviceOpenConsultingDoctorList - ОЗ. Операции. Открыто окно выбора врача
 * @property {string} serviceSelectedConsultingDoctor - ОЗ. Операции. Выбрали нового врача
 * @property {string} serviceOpenDoctorConsultationList - ОЗ. Операции. Открылась форма выбора первичной консультации
 * @property {string} serviceSelectedDoctorConsultation - ОЗ. Операции. Выбрали новую первичную консультацию
 *
 * @property {string} doctorPageBtnFixedShown - Страница врача. Проскроллили до момента когда отобразилась фиксированная кнопка "Записаться на приём"
 * @property {string} doctorPageBtnFixedClick - Страница врача. Нажали на кнопку "Записаться на приём"
 *
 * @property {string} clickSlotServicePriceListDirect - Страница списка цен клиники. Клик по слоту на странице - ОЗ
 */

/** @type {AppointmentYandexGoals} */
const APPOINTMENT_YANDEX_GOALS = {
  phoneConfirmed: 'appointment__phoneConfirmed',
  openFormDirect: 'appointment__openFormDirect',
  clickAppointmentDirect: 'appointment__clickAppointmentDirect',
  successDirect: 'appointment__successDirect',
  showCodeInput: 'appointment__showCodeInput',
  confirmedByCall: 'appointment__confirmedByCall',
  confirmedBySms: 'appointment__confirmedBySms',
  serviceOpenFormDirect: 'appointment__serviceOpenFormDirect',
  serviceClickAppointmentDirect: 'appointment__serviceClickAppointmentDirect',
  serviceOpenFormWithDoctor: 'appointment__serviceOpenFormWithDoctor',
  serviceOpenFormWithEquipment: 'appointment__serviceOpenFormWithEquipment',
  serviceOpenDoctorList: 'appointment__serviceOpenDoctorList',
  serviceSelectedDoctorKnown: 'appointment__serviceSelectedDoctorKnown',
  serviceSelectedDoctorUnknown: 'appointment__serviceSelectedDoctorUnknown',
  serviceOpenEquipmentList: 'appointment__serviceOpenEquipmentList',
  serviceSelectedEquipmentKnown: 'appointment__serviceSelectedEquipmentKnown',
  serviceSelectedEquipmentUnknown: 'appointment__serviceSelectedEquipmentUnknown',
  serviceOpenModalPreliminaryConsultation: 'appointment__serviceOpenModalPreliminaryConsultation',
  serviceClickConfirmPreliminaryConsultation: 'appointment__serviceClickConfirmPreliminaryConsultation',
  serviceClickDeclinePreliminaryConsultation: 'appointment__serviceClickDeclinePreliminaryConsultation',
  serviceFirstSelectedDoctorConsultation: 'appointment__serviceFirstSelectedDoctorConsultation',
  serviceOpenConsultingDoctorList: 'appointment__serviceOpenConsultingDoctorList',
  serviceSelectedConsultingDoctor: 'appointment__serviceSelectedConsultingDoctor',
  serviceOpenDoctorConsultationList: 'appointment__serviceOpenDoctorConsultationList',
  serviceSelectedDoctorConsultation: 'appointment__serviceSelectedDoctorConsultation',
  doctorPageBtnFixedShown: 'appointment__doctorPageBtnFixedShown',
  doctorPageBtnFixedClick: 'appointment__doctorPageBtnFixedClick',
  clickSlotServicePriceListDirect: 'appointment__clickSlotServicePriceListDirect',
}

export default APPOINTMENT_YANDEX_GOALS
